import React from 'react'
import { ClipLoader, MoonLoader } from 'react-spinners'
import { COLORS } from '../../config'

function SecondaryButtonAccent({
  onClick,
  ariaLabel,
  text,
  className,
  large,
  icon,
  disabled,
  buttonClassName,
  isLoading = false
}) {
  return (
    <div className={`${className} min-w-144`}>
      <button onClick={onClick} disabled={isLoading || disabled} aria-label={ariaLabel} className={`${disabled ? 'text-gray-300' : 'text-primary border-primary-light'} ${isLoading || disabled ? 'cursor-default' : 'hover:bg-blue-50'} flex justify-center items-center bg-white border rounded ${!large && 'py-1.5 px-2'} ${large && 'py-3 px-2 text-lg'} w-full ${buttonClassName}`}>
          {isLoading ? (
            <div className="mr-2 flex items-center justify-center">
              <ClipLoader
              size={20}
              color={COLORS.colorPrimary}
              cssOverride={{ marginRight: '8px' }}   
            />
            </div>
          ) : (
            icon && <div className="mr-1">{icon}</div>
          )}
          {text}
      </button>
    </div>
  )
}

export default SecondaryButtonAccent
